import {routes} from './app-routing';
import {ApplicationConfig} from '@angular/core';
import {provideHttpClient} from '@angular/common/http';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading} from '@angular/router';

export const appConfig: ApplicationConfig = {
  providers: [
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix: './assets/i18n/', suffix: '.json'})
    }),
    provideHttpClient(),
    provideRouter(routes,
      withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
      withPreloading(PreloadAllModules),
    ),
  ]
};
